// extracted by mini-css-extract-plugin
export default {"logo":"MainHeader_logo__8eJTK","nav":"MainHeader_nav__Ojpjr","breadcrumb":"MainHeader_breadcrumb__ta1lp"};